<div class="icon-container">
  <button mat-icon-button (click)="goToCart()">
    <mat-icon class="icon material-icons-outlined">shopping_cart_outlined</mat-icon>
  </button>
  <div class="counter">{{emptyCart() ? 0 : count()}}</div>
</div>
